<template>
  <div class="row_center_center used_coupon" v-for="(item, index) in coupons" :key="index">
    <div class="row_center_center coupon_used_img">
      <img src="@/assets/icon-used.png" />
    </div>
    <div class="coupon_detail" style="height: 120px;">
      <div class="column_start_start">
        <text class="coupon_title">{{ item.reward }}</text>
        <text class="coupon_descrption" style="-webkit-line-clamp: 2;">{{ item.description }}</text>
      </div>
      <div class="coupon_date">
        <!-- <p class="event_duration">
          活動期間：{{ item.eventStart }} ~ {{ item.eventEnd }}
        </p> -->
        <p class="usage_duration">
          使用期限：{{ item.usageStart }} ~ {{ item.expiry }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    coupons: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {};
  },
  mounted() { },
  methods: {},
};
</script>
<style lang="scss">
.used_coupon {
  width: 95vw;
  padding: 10px 2.5vw;
  height: 130px;
  border-bottom: dotted 1px #707070;
  margin-bottom: 10px;
  background-color: #fff;
  position: relative;
}


.coupon_used_img {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  background-image: url("@/assets/coupon_img.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;

  img {
    width: 120px;
    height: 120px;
  }
}

.used_coupon::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  /* 灰白色的遮罩 */
  pointer-events: none;
  /* 避免遮罩层阻挡交互 */
}
</style>
